import { WarningOutlined } from '@ant-design/icons'
import { Button } from 'aa_common/front-end/antd'
import { If } from 'aa_common/front-end/components'
import { ifElse } from 'aa_common/front-end/helpers'
import { Col, Collapse as AntCollapse, Image, Row, Typography } from 'antd'
import { getNs } from 'common/i18n-config'

import { CardContent, CardInformation, Collapse, RegisterInMaster, Warning } from '../styles'
import { Suggestion } from '../types'

const { t, useNsReady } = getNs(['common', 'components/organisms/assets/asset-form'])
const { Text, Title } = Typography
const { Panel } = AntCollapse

type AICardContentProps = {
  data: Suggestion
  imageSrc?: string
  onTryAgain?: () => void
  onReflect?: (suggestion?: Suggestion) => void
}

export const AICardContent = ({ data, imageSrc, onTryAgain, onReflect }: AICardContentProps) => {
  useNsReady()

  return (
    <CardContent>
      <CardInformation>
        <Row gutter={24} justify="space-between">
          {/* Image */}
          <If condition={imageSrc}>
            <Col span={6}>
              <Image width={96} src={imageSrc} />
            </Col>
          </If>

          {/* Details */}
          <Col span={17}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div>
                  <Text type="secondary">{t('name')}</Text>
                  <Title level={5}>{data?.asset_name}</Title>
                </div>
              </Col>

              <Col span={24}>
                <div>
                  <Text type="secondary">{t('asset_name_by_katakana')}</Text>
                  <Title level={5}>{data?.asset_name_by_katakana}</Title>
                </div>
              </Col>

              <Col span={14}>
                <div>
                  <Text type="secondary">{t('asset_category')}</Text>
                  <Title level={5} style={{ color: '#3b7de9' }}>
                    {data?.asset_category_name}
                  </Title>
                </div>
              </Col>

              <Col>
                <div>
                  <Text type="secondary">{t('service_life')}</Text>
                  <Title level={5} style={{ color: '#3b7de9' }}>
                    {data?.service_life}
                    {ifElse(data?.service_life, t('units.year'), '')}
                  </Title>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <If condition={data?.is_proposed_new_category}>
          <Warning>
            <Row gutter={16} justify="space-between" align="middle">
              <Col span={15}>
                <Row justify="space-between" align="middle">
                  <Col span={4}>
                    <WarningOutlined style={{ fontSize: '24px', color: '#fab300' }} />
                  </Col>
                  <Col span={20}>
                    <Text>{t('ai_warning_unregistered_asset_category')}</Text>
                  </Col>
                </Row>
              </Col>
              <Col span={9}>
                <RegisterInMaster to="/master/asset-categories/new">{t('register_in_master')}</RegisterInMaster>
              </Col>
            </Row>
          </Warning>
        </If>
      </CardInformation>

      <If condition={data?.reasoning}>
        <Collapse collapsible="header">
          <Panel header={t('show_decision_rationale')} key="1">
            <Text>{data?.reasoning}</Text>
          </Panel>
        </Collapse>
      </If>

      <Row gutter={16}>
        <Col span={12}>
          <Button block disabled={data?.is_proposed_new_category} onClick={() => onReflect?.(data)}>
            {t('reflect_to_form')}
          </Button>
        </Col>
        <Col span={12}>
          <Button color="grey" block onClick={onTryAgain}>
            {t('try_again')}
          </Button>
        </Col>
      </Row>
    </CardContent>
  )
}
